import axios from 'axios';
import { configClient } from 'components/provider/ConfigProvider'
import SecureStoreService from 'services/store/secure-store'
import { storeKeys } from 'services/store/keys'
import HelperVersion from 'utils/helper-version'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'

// Next we make an 'instance' of it
const createAxiosClient = async ({ contentType, ignoreAuth = false } = {} ) => {
	
	const employeeSession = await SecureStoreService.get( storeKeys.EMPLOYEE_SESSION )
	
	let config = {
		baseURL: configClient.url(),
		timeout: 15000,
		headers: {
			'Access-Control-Allow-Origin': '*',
			'appVersion': HelperVersion.getBuildVersion(),
			'appEnvironment': store.getState().data[ dataConstants.IN_MANAGEMENT ] ? 'management' : 'app',
		}
	}
	
	if( contentType ) {
		config.headers = {
			...config.headers,
			'Content-Type': contentType
		}
	}
	
	// Check for the session
	if( ignoreAuth !== true && employeeSession !== null ) {
		config.headers = {
			...config.headers,
			Authorization: employeeSession
		}
	}
	
	// Create the instance
	const instance =  axios.create( config );
	
	// Add a request interceptor
	instance.interceptors.response.use(
		response => {
			return response;
		},
        error => {
			return Promise.reject( error );
		}
	);
	
	return instance;
}

export default createAxiosClient;
